import {FormControl, FormGroup, Validators} from '@angular/forms';

export const DATA_UPDATE_FORM_CONST = {
  createForm: () => {
    return new FormGroup({
      dataUpdateType: new FormControl(undefined),
      hasRowLimited: new FormControl(false),
      numberOfRowLimited: new FormControl({value: undefined}),
      hasTopN: new FormControl(false),
      numberOfTopN: new FormControl({value: undefined}),
      id: new FormControl(undefined),
      updated: new FormControl(undefined),
      deleted: new FormControl(undefined),
      count: new FormControl(1),
      timeMode: new FormControl('Minute'),
    });
  },
}
